import { render } from "./ElHeader.vue?vue&type=template&id=64ec6483&scoped=true&lang=html"
import script from "./ElHeader.vue?vue&type=script&lang=js"
export * from "./ElHeader.vue?vue&type=script&lang=js"

import "./ElHeader.vue?vue&type=style&index=0&id=64ec6483&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ec6483"]])

export default __exports__